import React, { useEffect } from 'react'
import { Accordion, Alert, Card, InputGroup, useAccordionButton } from 'react-bootstrap'
import "../../stylesheets/animations.css";
import "../../stylesheets/home.css"
import { CSSTransition } from "react-transition-group"
import ImageCropper from './ImageCropper';
import axios from 'axios';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import HomeViewer from './HomeViewer';
import { Button } from 'react-bootstrap';
import { ExclamationCircle as ExclamationIcon } from "react-bootstrap-icons"
import { usePageContext } from '../contexts/PageContext';
import { useTranslation } from 'react-i18next';
import customProtocolCheck from "custom-protocol-check";
import { APILINK } from '../../EndPoint';

export default function HomeScanning({ canGoNext }) {
    const { setPage, croppedImages, setCroppedImages } = usePageContext();
    const { t } = useTranslation();

    const [images, setImages] = useState([{
        lang: "en",
        src: ""
    },
    {
        lang: "ar",
        src: ""
    }]);
    const history = useHistory();
    const [error, setError] = useState("");

    function sendImage() {
        if (canGoNext(croppedImages))
            setPage(2);
    }
    

    function getImage(i) {
        axios.get("http://localhost:8080/").then(
            res => {

                let arr = [...images];

                arr[i].src = res.data;
                setImages(arr);
                setError("");
                console.log(images)
            }
        ).catch(err => {
            // console.log(err.message)
            setError(t("errors.scanner"))
            if (err.message == "Network Error") {
                setError(t("errors.scanner"))
            }
        })
    }

    function remove(i) {
        let arr = [...images];
        arr[i].src = "";
        setImages(arr);
    }

    return (
        <div >
            <h4>{t("headerScanPage")}</h4>
            <p>
                <ExclamationIcon style={{ position: "relative", bottom: "2px" }} />{t("warningScannerApp.section1")}
                {
                    <span className="linkedText"
                        onClick={() => {
                            customProtocolCheck("iscan:", () => window.open(`${APILINK}/media/setup.exe`), () => window.open("iscan:", "_self"), 100)
                        }}
                    >{t("warningScannerApp.section2")}</span>
                }
            </p>            {/* <img src={image} /> */}
            <div className="imagesFragment">
                {
                    images && images.map((img, i) => {
                        console.log(img);
                        return (
                            <div className="imageContainer">
                                {
                                    img.src == "" ?
                                        <button className="scanButton disbleSelection"
                                            onClick={() => { getImage(i) }}
                                        >
                                            {`${t("scanPhoto")} ${t(img.lang)}`}

                                        </button>
                                        :
                                        <ImageCropper index={i} imageUrl={img}
                                            remove={() => remove(i)}
                                            retry={() => getImage(i)}
                                            setImage={(blob) => {
                                                blob && console.log("from Home: " + URL.createObjectURL(blob))
                                                const arr = [...croppedImages];
                                                arr[i] = blob;
                                                setCroppedImages(arr);
                                                console.log(croppedImages)
                                            }}
                                        />
                                }
                            </div>
                        )
                    })
                }

            </div>
            {
                error && <CSSTransition in={error != ""}
                    classNames="slideAnimation"
                    timeout={500}>
                    <div>
                        <Alert variant="danger">
                            <ExclamationIcon /> {error}
                        </Alert>
                    </div>
                </CSSTransition>
            }
            <div style={{ textAlign: "end", marginTop: "15px" }}>
                <button className="defaultButton" onClick={sendImage}>{t("buttons.next")}</button>
            </div>
        </div>
    )
}
